import { useRef, useState } from "react";
import { Camera, RefreshCw, ImagePlus } from "lucide-react";
import { fileToCompressedDataUrl } from "../lib/image";

export function PhotoCapture({ label, value, onChange, testid }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const dataUrl = await fileToCompressedDataUrl(file);
      onChange(dataUrl);
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-1.5" data-testid={`${testid}-container`}>
      <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
      <input ref={inputRef} type="file" accept="image/*" capture="environment" className="hidden"
             data-testid={`${testid}-input`} onChange={handleFile} />
      {value ? (
        <div className="relative rounded-lg overflow-hidden border border-slate-200 bg-slate-900">
          <img src={value} alt={label} className="w-full h-32 object-cover" data-testid={`${testid}-preview`} />
          <button type="button" onClick={() => inputRef.current?.click()}
                  data-testid={`${testid}-retake-button`}
                  className="absolute bottom-2 right-2 flex items-center gap-1 bg-navy/85 text-white text-xs px-2.5 py-1.5 rounded-md hover:bg-navy-800 transition-colors">
            <RefreshCw className="w-3 h-3" /> Repetir
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={loading}
                data-testid={`${testid}-capture-button`}
                className="w-full h-32 rounded-lg border-2 border-dashed border-slate-300 hover:border-cyan-500 hover:bg-cyan-50/40 transition-colors flex flex-col items-center justify-center gap-1.5 text-slate-500">
          {loading ? <RefreshCw className="w-5 h-5 animate-spin" /> : <Camera className="w-6 h-6" />}
          <span className="text-xs font-medium flex items-center gap-1"><ImagePlus className="w-3 h-3" /> Tomar / subir foto</span>
          <span className="text-[10px] text-slate-400">Máx. 100KB · 400×400px · compresión automática</span>
        </button>
      )}
    </div>
  );
}
